// src/components/layout/DashboardLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import SideNav from './SideNav';
import { Toaster } from "../ui/Sonner"

function DashboardLayout() {
  return (
    <div>
      {/* The Header is part of the DashboardLayout now */}
      <Header />
      <div className="flex">
        <aside className="w-64 fixed top-0 left-0 h-full pt-[62.5px]"> {/* pt value should match header height */}
          <SideNav />
        </aside>
        <main className="flex-1 ml-64 p-6"> {/* ml-64 to offset for the fixed sidebar */}
          {/* Outlet will render the matched dashboard child route element */}
          <Outlet />
        </main>
        <Toaster />
      </div>
    </div>
  );
}

export default DashboardLayout;